import BaseModel from "@/api/models/BaseModel";

/**
 * PaymentStatusDictionary
 */
export default class PaymentStatusDictionary extends BaseModel {
    
    constructor() {
        super();

        this.CREATED = 1;
        this.APPROVED = 2;
        this.REFUSED = 3;
        this.EXPIRED = 4;
    }

    /**
     * Retorna o label amigável baseado no ID ou no Type do Mercado Pago
     * @param {string} key 
     * @returns {string}
     */
    getLabel(key) {
        const labels = {
            [this.CREATED]: 'created',
            [this.APPROVED]: 'approved',
            [this.REFUSED]: 'refused',
            [this.EXPIRED]: 'expired',
        };

        return labels[key] || key || 'Não identificado';
    }

    /**
     * Gets all status
     * @param {array} ignore
     */
    getAll(ignore = []) {
        let status = {};

        for (let item of [this.CREATED, this.APPROVED, this.REFUSED, this.EXPIRED]) {
            if (ignore.includes(item)) {
                continue;
            }

            status[item] = this.getLabel(item);
        }

        return status;
    }

    /**
     * Método auxiliar para resolver o label a partir do objeto payment_method do payload
     * @param {Object} paymentMethodObject 
     */
    getLabelFromPayload(paymentMethodObject) {
        if (!paymentMethodObject) {
            return 'Não identificado';
        }

        const idLabel = this.getLabel(paymentMethodObject.id);
        if (idLabel !== paymentMethodObject.id) {
            return idLabel;
        }

        return this.getLabel(paymentMethodObject.type);
    }
}